import { Link } from 'react-router-dom';

const footerLinks = {
  影视分类: [
    { name: '电影', path: '/category/movie' },
    { name: '电视剧', path: '/category/tv' },
    { name: '动漫', path: '/category/anime' },
    { name: '综艺', path: '/category/variety' },
  ],
  关于我们: [
    { name: '品牌介绍', path: '/about' },
    { name: '用户口碑', path: '/about#reviews' },
    { name: '常见问题', path: '/about#faq' },
    { name: '联系方式', path: '/about#contact' },
  ],
  热门推荐: [
    { name: '流浪地球3', path: '/article/1' },
    { name: '长安十二时辰', path: '/article/3' },
    { name: '庆余年·第二季', path: '/article/7' },
    { name: '斗罗大陆·终极之战', path: '/article/9' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="text-xl font-bold bg-gradient-to-r from-red-400 to-amber-400 bg-clip-text text-transparent inline-block mb-4"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              屁屁影院
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              屁屁影院是您最佳的在线影视娱乐平台，提供海量高清电影、电视剧、动漫资源，无需注册即可免费观看。每日更新，随时随地享受优质观影体验。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">
                {title}
              </h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 屁屁影院 pipicinema.com — 精选影视资源在线观看
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer"
              rel="nofollow"
            >
              使用条款
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer"
              rel="nofollow"
            >
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}